import { Controller } from "@hotwired/stimulus"
import { followBottom } from "../utils/chat_scroll"
import { hasOpenReactionPicker } from "../utils/reaction_picker"

// Polling refresh for peer-to-peer chats (dating matches, connections),
// mirroring the assistant poll pattern at a modest interval: the messages
// endpoint returns { fingerprint, html } and we only re-render on change.
export default class extends Controller {
    static targets = ["thread"]
    static values = { url: String, interval: { type: Number, default: 5000 }, initialFingerprint: String }

    connect() {
        this._fingerprint = this.hasInitialFingerprintValue ? this.initialFingerprintValue : null
        this._scrollToBottom()
        this._timer = setInterval(() => this._poll(), this.intervalValue)
    }

    disconnect() {
        clearInterval(this._timer)
    }

    _poll() {
        if (document.hidden) return
        fetch(this.urlValue, { headers: { Accept: "application/json" }, credentials: "same-origin" })
            .then((r) => (r.ok ? r.json() : null))
            .then((data) => {
                if (!data || !data.ok) return
                this._updatePresence(data.presence)
                if (this._fingerprint === data.fingerprint) return
                // Replacing the thread would close a reaction picker the reader
                // has open. Keep the old fingerprint so the next poll (after
                // they've picked, or closed it) applies the change instead.
                if (hasOpenReactionPicker(this.threadTarget)) return
                this._fingerprint = data.fingerprint
                this.threadTarget.innerHTML = data.html
                this._scrollToBottom()
            })
            .catch(() => {})
    }

    // The header presence pill lives outside this controller's element, so
    // update it via a document-level hook rather than a Stimulus target.
    _updatePresence(presence) {
        if (!presence) return
        let pill = document.querySelector("[data-peer-presence]")
        if (pill) pill.hidden = !presence.online
    }

    _scrollToBottom() {
        let scroller = this.element.closest(".assistant-content") || this.element
        followBottom(this, scroller).contentChanged()
    }
}
